import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';

const getRootVariable = (variable) => {
  return getComputedStyle(document.documentElement).getPropertyValue(variable).trim()
}

const CustomSlider = styled(Slider)(({ accentcolor, accentlight, graycolor, isactive }) => ({
  color: isactive ? accentcolor : graycolor,
  height: 8,
  marginTop: 16, 
  '& .MuiSlider-track': {
    backgroundColor: isactive ? accentcolor : graycolor,
    border: 'none',
  },
  '& .MuiSlider-rail': {
    opacity: 0.5,
    backgroundColor: graycolor,
  },
  '& .MuiSlider-thumb': {
    height: 20,
    width: 20,
    backgroundColor: isactive ? accentcolor : 'transparent',
    border: `3.5px solid ${isactive ? accentlight : 'transparent'}`,
    boxShadow: '0 0 2px rgba(0, 0, 0, 0.1)',
    display: isactive ? 'block' : 'none',
    '&:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: isactive ? '0 0 4px rgba(0, 0, 0, 0.2)' : 'none',
    },
    '&::before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#000',
    top: -30,
    backgroundColor: 'transparent',
    display: isactive ? 'block' : 'none',
    transform: 'translateX(-30%)',
    '&::before': {
      display: 'none',
    },
    '& *': {
      transform: 'none',
    },
  },
}));

const MoodSlider = ({ mood, value, onChange }) => {
  const [colors, setColors] = useState({ 
    accent: '#F2726C', 
    light: '#f5d6d4', 
    gray: '#EAECF0' 
  });
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    const accentcolor = getRootVariable('--accent-color') || '#F2726C';
    const accentlight = getRootVariable('--accent-light') || '#f5d6d4';
    const graycolor = getRootVariable('--gray-200') || '#EAECF0';
    setColors({ accent: accentcolor, light: accentlight, gray: graycolor });
  }, [])

  const handleInteraction = (newVal) => {
    setIsActive(true)
    onChange(newVal)
  }

  return (
    <Box sx={{ width: '90%' }}>
      <CustomSlider
        aria-label={`Mood ${mood}`}
        defaultValue={1}
        value={value}
        onChange={(e, newVal) => handleInteraction(newVal)}
        onClick={() => setIsActive(true)}
        valueLabelDisplay="on" 
        step={1}
        min={1}
        max={5}
        accentcolor={colors.accent}
        accentlight={colors.light}
        graycolor={colors.gray}
        isactive={isActive ? 1 : 0}
      />
    </Box>
  );
};

export default MoodSlider;